import React from "react";

const RestaurantListItem = ({
  restaurant,
  onRestaurantSelect,
  getSelectedRestaurantId,
  openLink,
  innerWidth
}) => {
  const imageUrl = restaurant.imageUrl;

  return (
    <li
      name="list-item"
      onClick={event => {
        innerWidth < 768
          ? onRestaurantSelect(restaurant, event)
          : getSelectedRestaurantId(restaurant.id);
      }}
      className="restaurant-listing"
    >
      <div className="media-container">
        <div className="media-left">
          <div
            className="restaurant-logo"
            style={{ backgroundImage: 'url("' + restaurant.imageUrl + '")' }}
          />
        </div>
        <div className="media-body">
          <div className="restaurant-name">{restaurant.restaurantName}</div>
          <div className="restaurant-address">
            {!restaurant.unitNumber == "" ? restaurant.unitNumber + " - " : ""}
            {restaurant.streetAddress}
            <br />
            {restaurant.city +
              ", " +
              restaurant.province +
              ", " +
              restaurant.postalCode}
          </div>
          <button
            name="reserve-button"
            className="reserve-button yellow-button"
            onClick={() => {
              restaurant.reservationLink !== null
                ? openLink(restaurant.reservationLink)
                : openLink(restaurant.websiteLink);
            }}
          >
            RÉSERVER
          </button>
        </div>
      </div>
    </li>
  );
};

export default RestaurantListItem;
